import { consumer, core } from '@tock/coretypes';

/**
 * Turns a lat,lng string into a consumer search filter if possible.
 * @param {string?} latlng when present, formatted as comma-separated lat,lng eg. 90.90,-90.90
 * @param {string?} boundingBox when present, specifies top-left and bottom-right latlng coordinates
 * @returns {consumer.LocationSearchFilter?}
 */
export function getLocationSearchFilter(
  latlng?: string,
  boundingBox?: core.BoundingBox
): consumer.LocationSearchFilter | undefined {
  if (!latlng && !boundingBox) {
    return undefined;
  }

  const [lat, lng] = latlng?.split(',') || [undefined, undefined];

  const latitude = (lat && parseFloat(lat)) || NaN;
  const longitude = (lng && parseFloat(lng)) || NaN;
  const origin = isNaN(latitude) || isNaN(longitude) ? undefined : { latitude, longitude };

  if (!origin && !boundingBox) {
    return undefined;
  }

  return { origin, boundingBox };
}
